import * as React from 'react';
import { Link } from 'react-router-dom';

import './navDrawer.css'

export interface INavDrawerProps {
  isNavBarVisible: boolean,
  toggleDrawer: () => void
}

export default class NavDrawer extends React.PureComponent<INavDrawerProps, any> {

  public isDrawerVisible = () => {
    console.log('toggle');
    return (this.props.isNavBarVisible) ? 'side-drawer open' : 'side-drawer';
  };


  public render() {

    return (
      <nav className={this.isDrawerVisible()}>
        <ul className='drawerul'>
          {/* <li className='firstli'/> */}
          <li className='otherli'>
            <Link to='/photos/events' onClick={ this.props.toggleDrawer } >Events</Link>
          </li>
          <li className='otherli'>
            <Link to='/photos/lifestyle' onClick={ this.props.toggleDrawer } >Lifestyle</Link>
          </li>
          <li className='otherli'>
            <Link to='/photos/portraits' onClick={ this.props.toggleDrawer } >Portraits</Link>
          </li>
          <li className='otherli'>
            <Link to='/photos/published' onClick={ this.props.toggleDrawer } >Published</Link>
          </li>
          <li className='otherli'>
            <Link to='/profile' onClick={ this.props.toggleDrawer } >Profile</Link>
          </li>
      </ul>
    </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/bundles/common/components/navDrawer/navDrawer.tsx